// extracted by mini-css-extract-plugin
export var growableInput = "_5i-0";
export var tagContainer = "_5i-2";
export var textInput = "_5i-1";